import {authGuard} from '@common/auth/guards/auth-route';
import {RouteObject} from 'react-router';

/** Company/employer portal routes (account_type=company; gated in the layout). */
export const companyRoutes: RouteObject[] = [
  {
    path: 'company',
    lazy: () => import('@app/company/company-layout'),
    loader: () => authGuard({requireLogin: true}),
    children: [
      {index: true, lazy: () => import('@app/company/dashboard/company-dashboard-page')},
      // Offer builder: search the directory, shortlist for a client, send it.
      {path: 'directory', lazy: () => import('@app/company/directory/company-directory-page')},
      {path: 'offers', lazy: () => import('@app/company/offers/company-offers-page')},
      {path: 'offers/:offerId', lazy: () => import('@app/company/offers/company-offer-editor-page')},
      {path: 'jobs', lazy: () => import('@app/company/jobs/company-jobs-page')},
      {path: 'jobs/new', lazy: () => import('@app/company/listings/company-listing-editor-page')},
      {path: 'jobs/:listingId', lazy: () => import('@app/company/listings/company-listing-editor-page')},
      {path: 'scholarships', lazy: () => import('@app/company/scholarships/company-scholarships-page')},
      {path: 'scholarships/new', lazy: () => import('@app/company/listings/company-listing-editor-page')},
      {path: 'scholarships/:listingId', lazy: () => import('@app/company/listings/company-listing-editor-page')},
      {path: 'applicants', lazy: () => import('@app/company/applicants/company-applicants-page')},
      {path: 'analytics', lazy: () => import('@app/company/analytics/company-analytics-page')},
      {path: 'talent', lazy: () => import('@app/company/talent/company-talent-page')},
      {path: 'team', lazy: () => import('@app/company/team/company-team-page')},
      {path: 'profile', lazy: () => import('@app/company/profile/company-profile-page')},
    ],
  },
];
